/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseUUID } from '../models/ApiResponseUUID';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DriveHistoryExcelService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 주행기록 엑셀 다운로드 토큰 발급
   * 주행기록 엑셀 다운로드 토큰 발급
   * @returns ApiResponseUUID OK
   * @throws ApiError
   */
  public driveHistoryExcelDownloadToken({
    vin,
    clientTimezone,
    startDate = '20250904',
    endDate = '20250904',
    order = 'ASC',
  }: {
    /**
     * vin
     */
    vin: string,
    clientTimezone?: string,
    startDate?: string,
    endDate?: string,
    /**
     * Order By
     */
    order?: 'ASC' | 'DESC',
  }): CancelablePromise<ApiResponseUUID> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/excel/token',
      headers: {
        'Client-Timezone': clientTimezone,
      },
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
        'order': order,
      },
    });
  }
  /**
   * 엑셀파일 다운로드
   * 엑셀파일 다운로드
   * @returns string OK
   * @throws ApiError
   */
  public driveHistoryExcelDownload({
    token,
  }: {
    /**
     * Download Token
     */
    token: string,
  }): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/drive-history/excel/file',
      query: {
        'token': token,
      },
    });
  }
}
